// Moi SKU la mot thuc the rieng: chon o cot trai, xem day du o cot phai theo
// dung bo cuc man hinh "Cap nhat sku" that de doi chieu cho nhanh.

import { useEffect, useMemo, useState } from "react";
import { anhUrl, api } from "../api";
import { Badge, Empty, ErrorBox, QuyetDinhBadge, Spinner } from "../components/ui";
import type {
  AnhChiTiet,
  Dataset,
  ProductDetail,
  ProductList,
  ProductSummary,
  Truong,
} from "../types";

function Anh({ src, alt, className }: { src: string | null; alt: string; className?: string }) {
  const [hong, setHong] = useState(false);
  useEffect(() => setHong(false), [src]);
  if (!src || hong) return <span className="muted small">không tải được</span>;
  return <img src={src} alt={alt} className={className} loading="lazy" onError={() => setHong(true)} />;
}

/* ------------------------------------------------------------ cot trai */

function ItemSanPham({
  sp,
  active,
  onClick,
}: {
  sp: ProductSummary;
  active: boolean;
  onClick: () => void;
}) {
  return (
    <div className={`prod-item ${active ? "active" : ""}`} onClick={onClick}>
      <div className="prod-thumb">
        {sp.anh ? <Anh src={anhUrl(sp.anh)} alt={sp.ten} /> : <span>▢</span>}
      </div>
      <div className="prod-item-main">
        <div className="prod-item-name" title={sp.ten}>
          <span className="muted">#{sp.stt}</span> {sp.ten}
        </div>
        <div className="prod-item-meta">
          <span className="small muted truncate" style={{ maxWidth: 110 }}>{sp.brand}</span>
          {sp.so_tu_dong > 0 ? <Badge tone="ok">{sp.so_tu_dong} tự động</Badge> : null}
          {sp.so_can_duyet > 0 ? <Badge tone="warn">{sp.so_can_duyet} cần duyệt</Badge> : null}
        </div>
        <div className="bar" style={{ marginTop: 6 }} title={`${sp.so_da_dien}/${sp.so_truong} trường đã điền`}>
          <i style={{ width: `${Math.round(sp.tien_do * 100)}%` }} />
        </div>
      </div>
    </div>
  );
}

/* ----------------------------------------------------------- cot phai */

function KhoiAnh({ anh }: { anh: AnhChiTiet }) {
  const hienTai = anhUrl(anh.value);
  const deXuat = anh.de_xuat && anh.de_xuat !== anh.value
    ? anhUrl(anh.de_xuat, anh.file_local)
    : null;

  return (
    <div className="anh-block">
      <div className="section-title" style={{ textAlign: "left" }}>Hình ảnh sản phẩm</div>

      <div className="anh-pair">
        <div className="anh-one">
          <div className={`anh-frame ${hienTai ? "" : "empty-img"}`}>
            {hienTai ? <Anh src={hienTai} alt="ảnh hiện tại" /> : "Chưa có ảnh"}
          </div>
          <div className="anh-cap">Ảnh trên hệ thống</div>
        </div>

        {deXuat ? (
          <div className="anh-one">
            <div className="anh-frame">
              <Anh src={deXuat} alt="ảnh đề xuất" />
            </div>
            <div className="anh-cap">
              Ảnh đề xuất <QuyetDinhBadge qd={anh.quyet_dinh} diem={anh.diem} />
              {/* kich_thuoc la so do cua anh DE XUAT da tai ve, khong phai anh
                  dang nam tren he thong - gan nhan o day cho dung cho. */}
              {anh.kich_thuoc ? <div>{anh.kich_thuoc}</div> : null}
            </div>
          </div>
        ) : null}
      </div>

      <div className="anh-dims" style={{ marginTop: 10 }}>
        Kích thước đề xuất của hệ thống: <strong>400 × 400</strong>
      </div>

      {anh.ghi_chu ? (
        <div className="hint" style={{ marginTop: 6 }}>{anh.ghi_chu}</div>
      ) : null}

      {anh.ly_do.length > 0 ? (
        <ul className="reasons" style={{ textAlign: "left", maxWidth: 560, margin: "10px auto 0" }}>
          {anh.ly_do.map((r, i) => (
            <li key={i}>{r}</li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}

function MotTruong({ t }: { t: Truong }) {
  const coDeXuat = t.de_xuat != null && t.de_xuat !== "";
  const lop = t.co_gia_tri
    ? "sku-value"
    : coDeXuat
      ? `sku-value suggest ${t.de_xuat_quyet_dinh === "tu_dong" ? "auto" : ""}`
      : "sku-value blank";

  return (
    <div className="sku-field">
      <div className="label-row">
        <span className="label" style={{ margin: 0 }}>{t.ten}</span>
        {t.co_gia_tri ? null : coDeXuat ? (
          <QuyetDinhBadge qd={t.de_xuat_quyet_dinh} diem={t.de_xuat_diem} />
        ) : (
          <Badge>trống</Badge>
        )}
        {t.ghi_chu ? <Badge tone="danger" title={t.ghi_chu}>khoá</Badge> : null}
      </div>

      <div className={lop}>
        {t.co_gia_tri ? t.value : coDeXuat ? t.de_xuat : "chưa có dữ liệu"}
      </div>

      {!t.co_gia_tri && coDeXuat ? (
        <>
          {t.de_xuat_bang_chung ? (
            <div className="evidence">
              <span className="ev-label">Bằng chứng</span>
              {t.de_xuat_bang_chung}
            </div>
          ) : null}
          {t.de_xuat_ly_do.length > 0 ? (
            <ul className="reasons">
              {t.de_xuat_ly_do.map((r, i) => (
                <li key={i}>{r}</li>
              ))}
            </ul>
          ) : null}
          {t.de_xuat_on_dinh ? (
            <div className="hint">Độ ổn định: {t.de_xuat_on_dinh}</div>
          ) : null}
        </>
      ) : null}

      {t.so_lua_chon ? (
        <div className="hint">
          {t.so_lua_chon} lựa chọn{t.lua_chon_day_du === false ? " (chưa quét hết)" : ""}
        </div>
      ) : null}
    </div>
  );
}

function ChiTiet({ sp }: { sp: ProductDetail }) {
  const bs = sp.bo_sung;
  return (
    <div className="prod-detail-inner">
      <div className="sku-head">
        <div className="grow">
          <div className="sku-title">{sp.modal_title ?? "Cập nhật sku"}</div>
          <div style={{ marginTop: 5, fontSize: 14 }}>{sp.ten}</div>
          <div className="row wrap small muted" style={{ marginTop: 7, gap: 8 }}>
            <span>STT {sp.stt}</span>
            <span>·</span>
            <span>{sp.brand_da_chon || sp.brand}</span>
            <span>·</span>
            <span>{sp.sub_class}</span>
          </div>
        </div>
        <div className="col" style={{ gap: 6, alignItems: "flex-end" }}>
          <Badge tone={sp.status === "ok" ? "ok" : "danger"}>{sp.status}</Badge>
          <span className="small muted">
            {sp.so_da_dien}/{sp.so_truong} trường đã điền
          </span>
        </div>
      </div>

      <KhoiAnh anh={sp.anh_chi_tiet} />

      <div className="section">
        <div className="section-title">Thông tin sản phẩm</div>
        <div className="sku-grid">
          {sp.truong.map((t) => (
            <MotTruong key={t.ten} t={t} />
          ))}
        </div>
      </div>

      {bs.trang_lien_quan?.length ? (
        <div className="section">
          <div className="section-title">
            Nguồn tham chiếu ({bs.trang_lien_quan.length} trang · {bs.nguon_tim_kiem})
          </div>
          <div className="link-list">
            {bs.trang_lien_quan.slice(0, 8).map((p, i) => (
              <div className="link-item" key={i}>
                <div className="li-title">{p.tieu_de}</div>
                <a className="li-url" href={p.url} target="_blank" rel="noreferrer">
                  {p.url}
                </a>
                {p.trich_doan ? <div className="li-snip">{p.trich_doan}</div> : null}
              </div>
            ))}
          </div>
        </div>
      ) : null}

      {sp.anh_chi_tiet.da_kiem_tra.length ? (
        <div className="section">
          <div className="section-title">
            Ảnh ứng viên đã tải về kiểm tra ({sp.anh_chi_tiet.da_kiem_tra.length})
          </div>
          <div className="thumb-row">
            {sp.anh_chi_tiet.da_kiem_tra.slice(0, 12).map((a, i) => (
              <div className="thumb-card" key={i}>
                <div className="tc-frame">
                  <Anh src={anhUrl(a.url)} alt={`ứng viên ${i + 1}`} />
                </div>
                <div className="tc-cap">
                  {a.loi ? (
                    <span style={{ color: "var(--danger)" }}>{a.loi}</span>
                  ) : (
                    <>
                      {a.rong}×{a.cao} · {a.diem}đ
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : null}

      {sp.anh_chi_tiet.vision.length ? (
        <div className="section">
          <div className="section-title">Vision đọc nhãn trên bao bì</div>
          <div className="link-list">
            {sp.anh_chi_tiet.vision.map((v, i) => (
              <div className="link-item" key={i}>
                <div className="row wrap" style={{ gap: 8, marginBottom: 4 }}>
                  <Badge tone={v.khop ? "ok" : "danger"}>{v.khop ? "khớp" : "không khớp"}</Badge>
                  {v.ten_tren_anh ? <span className="small"><b>{v.ten_tren_anh}</b></span> : null}
                  {v.dung_tich_tren_anh ? <Badge tone="info">{v.dung_tich_tren_anh}</Badge> : null}
                </div>
                {v.ly_do ? <div className="li-snip">{v.ly_do}</div> : null}
              </div>
            ))}
          </div>
        </div>
      ) : null}

      <div className="section">
        <div className="section-title">Dữ liệu gốc</div>
        <dl className="kv">
          {Object.entries(sp.input).map(([k, v]) => (
            <div key={k} style={{ display: "contents" }}>
              <dt>{k}</dt>
              <dd>{v}</dd>
            </div>
          ))}
          {bs.tu_khoa?.length ? (
            <>
              <dt>Từ khoá tìm kiếm</dt>
              <dd className="mono">{bs.tu_khoa.join(" · ")}</dd>
            </>
          ) : null}
          {bs.llm_da_dung ? (
            <>
              <dt>LLM đã dùng</dt>
              <dd className="mono">{bs.llm_da_dung}</dd>
            </>
          ) : null}
          {bs.thoi_gian ? (
            <>
              <dt>Thời điểm làm giàu</dt>
              <dd>{bs.thoi_gian}</dd>
            </>
          ) : null}
        </dl>
      </div>
    </div>
  );
}

/* ---------------------------------------------------------------- trang */

export default function ProductsPage() {
  const [datasets, setDatasets] = useState<Dataset[] | null>(null);
  const [chonFile, setChonFile] = useState<string>("");
  const [ds, setDs] = useState<ProductList | null>(null);
  const [chonStt, setChonStt] = useState<number | null>(null);
  const [chiTiet, setChiTiet] = useState<ProductDetail | null>(null);
  const [tim, setTim] = useState("");
  // O kho hep chi hien duoc mot cot. Thuoc tinh nay cho CSS biet dang xem cot
  // nao; may rong thi CSS bo qua va van hien ca hai.
  const [xem, setXem] = useState<"danh-sach" | "chi-tiet">("danh-sach");
  const [loc, setLoc] = useState<"tat_ca" | "can_duyet" | "con_trong">("tat_ca");
  const [loi, setLoi] = useState<unknown>(null);
  const [dangTai, setDangTai] = useState(false);

  useEffect(() => {
    api
      .datasets()
      .then((r) => {
        setDatasets(r.datasets);
        // Uu tien file_finish: do la ban da lam giau + co de xuat cua AI.
        // file_output chi la ban thu thap tho, mo len gan nhu khong xem duoc gi.
        const co = r.datasets.filter((d) => d.so_san_pham > 0);
        const dau = co.find((d) => d.folder === "file_finish") ?? co[0];
        if (dau) setChonFile(`${dau.folder}|${dau.file}`);
      })
      .catch(setLoi);
  }, []);

  useEffect(() => {
    if (!chonFile) return;
    const [folder, file] = chonFile.split("|");
    setDangTai(true);
    setChiTiet(null);
    setChonStt(null);
    api
      .products(folder, file)
      .then((r) => {
        setDs(r);
        setLoi(null);
        if (r.items.length) setChonStt(r.items[0].stt);
      })
      .catch(setLoi)
      .finally(() => setDangTai(false));
  }, [chonFile]);

  useEffect(() => {
    if (!ds || chonStt == null) return;
    api
      .product(ds.folder, ds.file, chonStt)
      .then(setChiTiet)
      .catch(setLoi);
  }, [ds, chonStt]);

  const hienThi = useMemo(() => {
    if (!ds) return [];
    const q = tim.trim().toLowerCase();
    return ds.items.filter((i) => {
      if (loc === "can_duyet" && i.so_can_duyet === 0) return false;
      if (loc === "con_trong" && i.so_trong === 0) return false;
      if (!q) return true;
      return (
        i.ten.toLowerCase().includes(q) ||
        i.brand.toLowerCase().includes(q) ||
        String(i.stt) === q
      );
    });
  }, [ds, tim, loc]);

  if (loi && !ds) {
    return <div className="content-pad"><ErrorBox error={loi} /></div>;
  }

  if (datasets && datasets.length === 0) {
    return (
      <Empty icon="▤">
        Chưa có file kết quả nào. Chạy bước 3 (thu thập) rồi bước 4 (làm giàu) trước.
      </Empty>
    );
  }

  return (
    <div className="prod" data-xem={xem}>
      <div className="prod-list">
        <div className="prod-list-head">
          <select
            className="select"
            value={chonFile}
            onChange={(e) => setChonFile(e.target.value)}
          >
            {datasets?.map((d) => (
              <option key={`${d.folder}|${d.file}`} value={`${d.folder}|${d.file}`}>
                {d.file} ({d.so_san_pham} SKU)
              </option>
            ))}
          </select>

          <input
            className="input"
            style={{ marginTop: 8 }}
            placeholder="Tìm theo tên, brand hoặc STT…"
            value={tim}
            onChange={(e) => setTim(e.target.value)}
          />

          <div className="row" style={{ marginTop: 8, gap: 5 }}>
            {([
              ["tat_ca", "Tất cả"],
              ["can_duyet", "Cần duyệt"],
              ["con_trong", "Còn trống"],
            ] as const).map(([v, nhan]) => (
              <button
                key={v}
                className={`btn btn-sm ${loc === v ? "btn-primary" : ""}`}
                onClick={() => setLoc(v)}
              >
                {nhan}
              </button>
            ))}
          </div>

          {ds ? (
            <div className="row wrap small muted" style={{ marginTop: 9, gap: 7 }}>
              <span>{hienThi.length}/{ds.tong.so_san_pham} SKU</span>
              {ds.tong.so_can_duyet > 0 ? (
                <Badge tone="warn">{ds.tong.so_can_duyet} cần duyệt</Badge>
              ) : null}
              {ds.tong.so_tu_dong > 0 ? (
                <Badge tone="ok">{ds.tong.so_tu_dong} tự động</Badge>
              ) : null}
            </div>
          ) : null}
        </div>

        <div className="prod-list-body">
          {dangTai ? (
            <div className="row" style={{ padding: 16 }}><Spinner /> Đang tải…</div>
          ) : hienThi.length === 0 ? (
            <Empty>Không có SKU nào khớp bộ lọc.</Empty>
          ) : (
            hienThi.map((sp) => (
              <ItemSanPham
                key={sp.stt}
                sp={sp}
                active={chonStt === sp.stt}
                onClick={() => {
                  setChonStt(sp.stt);
                  setXem("chi-tiet");
                }}
              />
            ))
          )}
        </div>
      </div>

      <div className="prod-detail">
        {chiTiet ? (
          <>
            <div style={{ padding: "12px 14px 0" }}>
              <button
                className="btn btn-sm nut-quay-lai"
                onClick={() => setXem("danh-sach")}
              >
                ← Danh sách sản phẩm
              </button>
            </div>
            <ChiTiet sp={chiTiet} />
          </>
        ) : dangTai || chonStt != null ? (
          <div className="row" style={{ padding: 30 }}><Spinner /> Đang tải chi tiết…</div>
        ) : (
          <Empty icon="◧">Chọn một sản phẩm ở cột bên trái.</Empty>
        )}
      </div>
    </div>
  );
}
